/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { Record } from 'immutable'
import { PasswordResetActionTypes } from '../../action/user/PasswordResetActions'

const PasswordResetState = Record({
  email: '',
  linkSent: false
})

class PasswordResetStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new PasswordResetState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case PasswordResetActionTypes.handleEmailEdit:
        return state.merge({ email: payload.email })
      case PasswordResetActionTypes.sendLink:
        return state.merge({ linkSent: true })
      default:
        return state
    }
  }
}

export default new PasswordResetStore()
